package com.cybersoftsolution.cybersoftsolutionweb.models.ui


import com.cybersoftsolution.cybersoftsolutionweb.models.Category
import com.cybersoftsolution.cybersoftsolutionweb.models.Page
import com.cybersoftsolution.cybersoftsolutionweb.models.SimplePost


data class HomePageUI(



    var searchText: String = "",
    var searchCategory: Category? = null,
    var toastMessage: ToastMessage = ToastMessage(),

    //subscribe
    var isSubscribe: Boolean = false,
    var isSubscribing: Boolean = false,
    var email: String = "",

    val isProductionMode: Boolean? = null,


    )


